import{curry as r,reduce as n,replace as t,toPairs as o}from"ramda";var a=r((function(r,a){return n((function(r,n){var o=n[0],a=n[1];return t("{{".concat(o,"}}"),a,r)}),r,o(a))}));export{a as formatString};
